import { css, cx } from 'emotion';
import {
	desktopMaxWidthBreakpoint,
	tabletLandscapeMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
	headingLarge,
	textBlock,
} from 'inside-out/global-styles';

export const imgStyle = css({
	background: '#F6F6F6',
	width: '350px',
	height: '300px',
	margin: '15px 0 0 30px',
	position: 'relative',
	borderRadius: '6px',
	'& img': {
		width: '100%',
		height: '100%',
		display: 'block',
		position: 'absolute',
		borderRadius: '6px',
		top: '-30px',
		left: '-30px',
	},
	[`@media (max-width: ${tabletLandscapeMaxWidthBreakpoint}px)`]: {
		width: '297px',
		height: '255px',
	},
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		width: '201px',
		height: '174px',
		margin: '15px 0 41px 30px',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

export const titleStyle = cx(
	headingLarge,
	css({
		marginBottom: '31px',
	})
);

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '70px auto',
	padding: '0 20px',
	'& p': cx(
		textBlock,
		css({
			maxWidth: '800px',
			[`@media (max-width: ${tabletLandscapeMaxWidthBreakpoint}px)`]: {
				maxWidth: '534px',
			},
		})
	),
	'&:after': {
		display: 'block',
		content: "' '",
		clear: 'both',
	},
	'&:nth-child(odd)': {
		[`& > * `]: {
			'&:first-child': {
				float: 'left',
			},
			'&:last-child': {
				float: 'right',
			},
		},
	},
	'&:nth-child(even)': {
		[`& > *`]: {
			'&:first-child': {
				float: 'right',
			},
			'&:last-child': {
				float: 'left',
			},
		},
	},
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		[`& > *`]: {
			float: 'none !important',
		},
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		margin: '30px auto',
	},
});

export const ContentStyle = css({
	maxWidth: '668px',
});



// WEBPACK FOOTER //
// ./src/page-styles/about-us/what-we-do/index.js